var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PepperFlowImportStepper'),_vm._v(" "),(_vm.step === 1)?_c('PepperFlowImportConnection'):(_vm.step === 2)?_c('PepperFlowImportDocuments'):(_vm.step === 3)?_c('PepperFlowImportPermissions'):(_vm.step === 4)?_c('PepperFlowImportFolders'):(_vm.step === 5)?_c('PepperFlowImportReview'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }